// ./src/contexts/VolunteerRolesContext/VolunteerRolesContext.tsx
//
// Thin context wrapper around the useVolunteerRoles hook. All derived data lives
// in the hook itself. See PoliciesContext for the pattern.

import React, { createContext, useContext } from "react";

import { useVolunteerRoles, UseVolunteerRolesOptions, UseVolunteerRolesReturn } from "@/hooks/useVolunteerRoles";

const VolunteerRolesContext = createContext<UseVolunteerRolesReturn | null>(null);

export interface VolunteerRolesProviderProps extends UseVolunteerRolesOptions {
  children: React.ReactNode;
}

export const VolunteerRolesProvider: React.FC<VolunteerRolesProviderProps> = ({ children, ...options }) => {
  const value = useVolunteerRoles(options);

  return <VolunteerRolesContext.Provider value={value}>{children}</VolunteerRolesContext.Provider>;
};

export const useVolunteerRolesContext = (): UseVolunteerRolesReturn => {
  const context = useContext(VolunteerRolesContext);

  if (!context) {
    throw new Error(
      "useVolunteerRolesContext must be used within a <VolunteerRolesProvider>. " +
        "Wrap your component tree with <VolunteerRolesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalVolunteerRolesContext = (): UseVolunteerRolesReturn | null => {
  return useContext(VolunteerRolesContext);
};
